import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/first-floor',
    name: 'First Floor',
    component: () => import('../views/FirstFloor.vue')
  },
  {
    path: '/second-floor',
    name: 'Second Floor',
    component: () => import('../views/SecondFloor.vue')
  },
  {
    path: '/third-floor',
    name: 'Third Floor',
    component: () => import('../views/ThirdFloor.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
